import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/figtree/wght.css';
import './index.css';
import './i18n';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);
